import React, { useState } from "react";
import { Box, Divider, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import { getTaskFieldSchema, getTaskTabs } from "../../suppliersMock";
import { TaskFieldSections } from "./TaskField";
import ProductTable from "./ProductTable";
import EmissionsByDivisionTable from "./EmissionsByDivisionTable";

// The Disclosure form for a data type. Product collects multiple SKUs, so it
// renders as a table; data types with questionnaire tabs (e.g. Revenue:
// General / Scope 1 / 2 / 3) render a primary tab strip; otherwise the flat
// field schema renders directly. Scope tabs with a `table` config render an
// emissions-by-division table instead of a field form.
function TaskDataTypePanel({
  dataType, values, onFieldChange, productRows, onProductRowsChange,
  divisions = [], emissions = {}, onEmissionsChange,
}) {
  const tabs = getTaskTabs(dataType);
  const [tab, setTab] = useState(0);

  if (dataType === "Product") {
    return <ProductTable rows={productRows || []} onChange={onProductRowsChange} />;
  }

  if (!tabs) {
    const schema = getTaskFieldSchema(dataType);
    return schema.length === 0
      ? <Text color="gray.400" fontSize="14px">No fields configured for this data type.</Text>
      : <TaskFieldSections schema={schema} values={values} onFieldChange={onFieldChange} />;
  }

  return (
    <Box>
      <Tabs variant="primary" index={tab} onChange={setTab} isLazy>
        <TabList>
          {tabs.map((t) => (
            <Tab key={t.id}>{t.label}</Tab>
          ))}
        </TabList>
        <Divider />
        <TabPanels>
          {tabs.map((t) => (
            <TabPanel key={t.id} px={0} pt={6}>
              {t.table ? (
                <EmissionsByDivisionTable
                  title={t.table.title}
                  description={t.table.description}
                  categories={t.table.categories}
                  divisions={divisions}
                  values={emissions[t.id] || {}}
                  onChange={(category, division, value) => onEmissionsChange?.(t.id, category, division, value)}
                />
              ) : t.sections?.length ? (
                <TaskFieldSections schema={t.sections} values={values} onFieldChange={onFieldChange} />
              ) : (
                <Text color="gray.400" fontSize="14px">Coming soon.</Text>
              )}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
}

export default TaskDataTypePanel;
